import { render } from "./ModalBig.vue?vue&type=template&id=1b4da921&scoped=true"
import script from "./ModalBig.vue?vue&type=script&lang=js"
export * from "./ModalBig.vue?vue&type=script&lang=js"

import "./ModalBig.vue?vue&type=style&index=0&id=1b4da921&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4da921"]])

export default __exports__